import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { post } from "sr/utils/axios";

export const createAccessToken = async (postData:any) => {
    try {
  return await post<ApiResponse<[]>>('/kyc/accesstoken', postData).then((res)=>{
        if(res?.success===true){
            return res
        }
        else {
            return null
        }
  })
}
catch(e){
    HandleApiError(e)
}
};
